import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import imagenProfile from "../../assets/img/user/user-13.jpg";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Store, ReactNotifications } from "react-notifications-component";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { AppSettings } from "../../config/app-settings.js";
import SweetAlert from "react-bootstrap-sweetalert";
import person from "../../assets/img/user/user-13.jpg";
import { count_type, pension_type, status } from "../../utils/index.js";
import Moment from "moment";
import { instance } from "../../utils/index.js";

import {
    deleteCountId,
  removeFilesOpen,
  getFilesId,

  getUsers,getCountsId
} from "../../actions/index.js";
import TablePrueba from "./tablaTest";
import { ReactToPrint  } from "react-to-print";
class VerConteo extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);
    this.state = {
      path: props.match.params.id,
      actual_date: Moment().format("L"),
      before_date: Moment().subtract(1, "days").format("L"),
      sweetAlertPrimary: false,
      sweetAlertInfo: false,
      sweetAlertWarning: false,
      sweetAlertSuccess: false,
      sweetAlertError: false,
      modalAsignment: false,
      modalReject: false,
      AsignaraError: false,
      AsignaraCommentError: false,
      Asignara: "",
      comentarioAsignar: "",
      comentarioFacebook: "",
    };
    this.toggleSweetAlert = this.toggleSweetAlert.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitComentarioFace = this.submitComentarioFace.bind(this);
    this.addNotification = this.addNotification.bind(this);
    this.submitReject = this.submitReject.bind(this);
  
  }
  addNotification(
    notificationType,
    notificationTitle,
    notificationMessage,
    notificationPosition,
    notificationContent
  ) {
    if (notificationContent) {
      notificationContent = (
        <div className="d-flex align-items-center bg-gray-900 rounded p-2 text-white w-100">
          <img src={imagenProfile} width="52" alt="" className="rounded" />
          <div className="flex-1 ps-2">
            <h6 className="mb-1">Christopher Struth</h6>
            <p className="mb-0">Bank Transfer</p>
          </div>
        </div>
      );
    }
    Store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
      content: notificationContent,
    });
  }
  tableRef = React.createRef();

  componentWillMount() {
    const { getFilesId, getUsers,getCountsId } = this.props;
    getFilesId(this.state.path);
    getUsers();
    getCountsId(this.state.path);
  }
  toggleModal(name) {
    switch (name) {
      case "modalAddTask":
        this.setState({ modalAsignment: !this.state.modalAsignment });
        break;
      case "modalReject":
        this.setState({ modalReject: !this.state.modalReject });
        break;
      default:
        break;
    }
  }

  toggleSweetAlert(name) {
    switch (name) {
      case "primary":
        this.setState({ sweetAlertPrimary: !this.state.sweetAlertPrimary });
        break;
      case "info":
        this.setState({ sweetAlertInfo: !this.state.sweetAlertInfo });
        break;
      case "success":
        this.setState({ sweetAlertSuccess: !this.state.sweetAlertSuccess });
        break;
      case "warning":
        this.setState({ sweetAlertWarning: !this.state.sweetAlertWarning });
        break;
      case "error":
        this.setState({ sweetAlertError: !this.state.sweetAlertError });
        break;
      default:
        break;
    }
  }

  submitComentarioFace(event) {
   
    event.target.reset();
    event.preventDefault();
    var bodyFormData = new FormData();
    bodyFormData.append("parent", event.target.id);
    bodyFormData.append("comment", this.state.comentarioFacebook);
    instance
      .post(`files/${this.state.path}/comment`, bodyFormData)
      .then((res) => {
       
        if (res.status === 201 || res.status === 200) {
          this.setState({
            comentarioFacebook: "",
          });

          this.props.getFileRoadmap(this.state.path);
        }
      })
      .catch((e) => console.log("Error in asignament", e));
  }
  submitReject(event) {
    
    event.preventDefault();

    if (this.state.comentarioAsignar === "") {
      this.setState({ AsignaraCommentError: !this.state.AsignaraCommentError });
      setTimeout(() => {
        this.setState({
          AsignaraCommentError: !this.state.AsignaraCommentError,
        });
      }, 1000);
    }
    var bodyFormData = new FormData();

    bodyFormData.append("comment", this.state.comentarioAsignar);
    instance
      .post(`files/${this.state.path}/assign`, bodyFormData)
      .then((res) => {
        
        if (res.status === 201) {
          this.setState({
            Asignara: "",
            comentarioAsignar: "",
          });
          this.toggleModal("modalAddTask");
          this.props.getFileRoadmap(this.state.path);
        }
      })
      .catch((e) => console.log("Error in asignament", e));
  }
  

 
  handleSubmit() {
    instance
      .post(`files/${this.state.path}/accept`)
      .then((res) => {
        
        if (res.status === 201 || res.status === 200) {
          this.addNotification(
            "default",
            "",
            `Expediente # ${this.state.path} copiado`,
            "bottom-center"
          );

          this.props.getFileRoadmap(this.state.path);
        }
      })
      .catch((e) => console.log("Error in asignament", e));
  }
  componentDidMount() {
    this.context.handleSetAppSidebarTwo_count(true);
  }

  componentWillUnmount() {
    this.context.handleSetAppSidebarTwo_count(false);
  }
  render() {
    const {  countId,deleteCountId } = this.props;

    
     function discriminate(val, option) {
      var factor = 1 / 12;
      var base =countId.count_type == 10 ? 360 : 365;
      var year = Math.floor(val / base);
      base = val / base - year;
      var month = Math.floor(base / factor);
      base = base / factor;
      base = base - Math.floor(base);
      var days = Math.floor(base * 30);
      if (option == "year") {
        return Math.round(year);
      } else if (option == "months") {
        return Math.round(month);
      } else if (option == "days") {
        return Math.round(days);
      } else {
        return Math.round(val / 7);
      }
    }
    const columnsForTable =[
      {
        Header: "Empleador",
        accessor: "employer",
        sortable: true,
      },
      {
        Header: "Cotizado A",
        accessor: "contribution",
        sortable: true,
      },
      {
        Header: "Tipo Aporte",
        accessor: "contribution_type",
        sortable: true,
      },

      {
        Header: "Ingreso",
        accessor: "start_date",
        sortable: true,
      },
      {
        Header: "Egreso",
        accessor: "end_date",
        sortable: true,
      },
      {
        Header: "Total parcial",
        accessor: "partial_total",
        sortable: true,
      },
      {
        Header: "Dias Sim",
        accessor: "simultaneous_days",
        sortable: true,
      },

      {
        Header: "Total Días",
        accessor: "days_total",
        sortable: true,
      },

    ]

    function print(firstTable,secondTable,countId) {
      const daysTotal =countId?.days_total;
      const weekTtotal =  Math.round(daysTotal / 7)

      let innerHtmlTableone=`<table   className="table table-panel table-bordered mb-0" style={{minWidth:"40rem"}}>
      <thead
     
        style={{
        
          fontSize: "1rem",
        }}
      >
        <tr className="d-flex ">
          <th className="col-4">Nombre del cliente</th>
          <th className="col text-center">Identificación</th>
          <th className="col text-center">Fecha de nacimiento</th>
       
        </tr>
      </thead>
      <tbody>  <tr>
      <td>${countId.name}</td>
      <td>${countId.document}</td>
      <td>${countId.birth}</td>
    </tr>  </tbody></table>`
    let innerHtmlTableTwo=` <table   className="table table-panel table-bordered mb-0" style={{minWidth:"40rem"}}>
    <thead
   
      style={{
      
        fontSize: "1rem",
      }}
    >
      <tr className="d-flex ">
        <th className="col-4">Tipo de pensión</th>
        <th className="col text-center">Tipo de Conteo</th>
        <th className="col text-center">Conteo Número</th>
        <th className="col text-center">Responsable</th>
     
      </tr>
    </thead>
    <tbody>  <tr>
    <td>${pension_type(countId.pension_type)}</td>
    <td>${count_type(countId.count_type) } días</td>
    <td>${countId.id}</td>
    <td>${countId.user.full_name}</td>
  </tr>  </tbody></table>`
let innerHtmlTableComents= `<table>
<thead

  style={{
  
    fontSize: "1rem",
  }}
>
  <tr className="">
    <th className="col-4">Observaciones</th>
  </tr>
</thead>
<tbody>  <tr>

<td>${countId.comments}</td>
</tr>  </tbody></table>`
let innerHtmlTableDays= `<div class="contain_days"><div class="empy_div"></div><div class="total_days"><table>
<thead>
  <tr className="">
    <th >Días totales</th>
    <th >Semanas totales</th>
  </tr>
</thead>
<tbody>
<tr>
<td>${daysTotal}</td>
<td>${weekTtotal}</td>
</tr>
</tbody></table></div></div>`
let tableItems = secondTable ? secondTable.innerHTML :``;
let tableResumen = firstTable ? firstTable.innerHTML :``;

      let innerHTML = `<!DOCTYPE html>
      <html lang="pt-BR">
      <head>   
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
      <link href="/stylesPrint.css" rel="stylesheet" />
      <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap" rel="stylesheet">
      </head>
      <body><main><div id='impresionReview'>
         <div class="watermark"></div>
         <div class="containerLogo">
         <div class="textoLogo"><h1>Conteo del Expediente No. ${countId.file.number}</h1>
         </div> 
         <div class="container_img"><img src="/assets/logo1.png" alt="logo"/>
         </div>
         </div>`;
      innerHTML +=innerHtmlTableone + innerHtmlTableTwo + tableResumen  + innerHtmlTableDays + tableItems  + innerHtmlTableComents + `</div></main> <div class="page-footer"><span>${localStorage.full_name}</span><span>${Moment().format("D [de] MMMM [del] YYYY, h:mm a")}</span></div></body></html>`;
      
      let fakeIFrame = window.document.createElement("iframe");
    
      document.body.appendChild(fakeIFrame);
      let fakeContent = fakeIFrame.contentWindow;
      fakeContent.document.open();
      fakeContent.document.write(innerHTML);
      fakeContent.document.close();
      setTimeout(() => {
        fakeContent.focus();
        fakeContent.print();
        fakeIFrame.remove();
      }, 300);
  }
    function printLikeLegacy(countId) {
      const escapeHtml = (value) =>
        String(value ?? "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");

      const items = Array.isArray(countId?.items) ? [...countId.items] : [];
      items.sort((a, b) => {
        const aDate = new Date(a?.start_date || a?.ingreso || 0).getTime();
        const bDate = new Date(b?.start_date || b?.ingreso || 0).getTime();
        return aDate - bDate;
      });

      const rowsItems = items
        .map(
          (item) => `
            <tr>
              <td>${escapeHtml(item?.employer || item?.empleador || "-")}</td>
              <td>${escapeHtml(item?.contribution || item?.cotizado_a || "-")}</td>
              <td>${escapeHtml(item?.contribution_type || item?.tipo_aporte || "-")}</td>
              <td>${escapeHtml(item?.start_date || item?.ingreso || "-")}</td>
              <td>${escapeHtml(item?.end_date || item?.egreso || "-")}</td>
              <td>${escapeHtml(item?.partial_total || item?.total_parcial || 0)}</td>
              <td>${escapeHtml(item?.simultaneous_days || item?.dias_simult || 0)}</td>
              <td>${escapeHtml(item?.days_total || item?.total_dias || 0)}</td>
            </tr>
          `
        )
        .join("");

      const countRows = [
        { label: "Público No Cotizado a Cajas", key: "public_no_fund" },
        { label: "Público Cotizado a Cajas", key: "public_fund" },
        { label: "Fondo", key: "fund" },
        { label: "Total Público", key: "public_total" },
        { label: "Tiempo Cotizado al 1 Abril 94", key: "time_94" },
        { label: "Tiempo Cotizado al 22 de Julio 2005", key: "time_2005" },
        { label: "Privado Tradicionales", key: "private_traditional" },
        { label: "Privado Autoliss", key: "private_autoliss" },
        { label: "Total Privado", key: "private_total" },
        { label: "Total Cotizaciones", key: "total_contributions" },
      ];

      const rowsResumen = countRows
        .map((item) => {
          const value = Number(countId?.[item.key] || 0);
          return `
            <tr>
              <td style="text-align:left">${escapeHtml(item.label)}</td>
              <td>${value}</td>
              <td>${discriminate(value, "year")}</td>
              <td>${discriminate(value, "months")}</td>
              <td>${discriminate(value, "days")}</td>
              <td>${discriminate(value, "weeks")}</td>
            </tr>
          `;
        })
        .join("");

      const daysTotal = Number(countId?.days_total || 0);
      const weekTotal = Math.round(daysTotal / 7);
      const observations =
        countId?.comments && String(countId.comments).trim().length > 0
          ? countId.comments
          : "No hay observaciones.";

      const printHtml = `<!DOCTYPE html>
      <html lang="es">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
          <link href="/stylesPrint.css" rel="stylesheet" />
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap" rel="stylesheet">
          <style>
            :root { --brand-blue: #2f7faf; --line: #d8d8d8; --text: #2f2f2f; }
            * { box-sizing: border-box; }
            body { font-family: 'Open Sans', Arial, sans-serif; margin: 28px 36px; color: var(--text); }
            .print-wrap { position: relative; }
            .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #e5e5e5; padding-bottom: 12px; margin-bottom: 16px; }
            .title { color: var(--brand-blue); font-size: 24px; line-height: 1.1; font-weight: 800; margin: 0; }
            .logo { width: 320px; max-width: 38%; }
            .meta-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px 22px; margin-bottom: 8px; }
            .meta-grid-4 { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 8px 22px; margin-bottom: 18px; }
            .label { color: var(--brand-blue); font-size: 13px; line-height: 1.1; font-weight: 800; margin-bottom: 2px; }
            .value { font-size: 14px; line-height: 1.2; font-weight: 600; }
            table { width: 100%; border-collapse: collapse; margin: 0; page-break-inside: auto !important; }
            .items-table { border: 1px solid #cfcfcf; margin-top: 8px; }
            .items-table thead th { background: #efefef; border: 1px solid #cfcfcf; text-align: left; padding: 9px 8px; font-size: 13px; font-weight: 700; }
            .items-table tbody td { border: 1px solid #cfcfcf; padding: 8px; font-size: 12px; vertical-align: top; }
            .summary-head { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 16px; }
            .summary-title { font-size: 22px; font-weight: 800; margin: 0; }
            .totals { font-size: 16px; font-weight: 700; }
            .resumen-table { margin-top: 8px; border-top: 2px solid #d9d9d9; }
            .resumen-table th, .resumen-table td { border: 0; padding: 6px 10px; font-size: 13px; }
            .resumen-table thead th { font-size: 13px; font-weight: 700; text-align: right; color: #3e3e3e; }
            .resumen-table thead th:first-child { text-align: left; }
            .resumen-table tbody td:first-child { color: var(--brand-blue); font-weight: 700; text-align: left; width: 52%; }
            .resumen-table tbody td:nth-child(2) { font-size: 16px; font-weight: 800; }
            .resumen-table tbody td { text-align: right; font-weight: 700; }
            .obs-title { font-size: 22px; margin: 16px 0 4px; font-weight: 800; }
            .obs { font-size: 14px; line-height: 1.35; font-weight: 600; text-transform: uppercase; }
            .print-footer { margin-top: 18px; display: flex; justify-content: space-between; font-size: 11px; color: #666; }
            .watermark-brand { position: fixed; inset: 0; background: url('/assets/watermark.png') no-repeat center 58%; background-size: 64%; opacity: 0.07; z-index: -1; pointer-events: none; }
            thead { display: table-header-group; }
            tr { page-break-inside: avoid; page-break-after: auto; }
            .summary-block { page-break-inside: avoid; break-inside: avoid; }
            @media print {
              body { margin: 26px 34px; padding-bottom: 48px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              .items-table { page-break-inside: auto !important; }
              .print-footer {
                position: fixed;
                left: 34px;
                right: 34px;
                bottom: 10px;
                margin-top: 0;
                padding-top: 6px;
                border-top: 1px solid #d9d9d9;
                background: #fff;
              }
            }
          </style>
        </head>
        <body>
          <div class="watermark-brand"></div>
          <div class="print-wrap">
            <div class="header">
              <h1 class="title">Conteo del Expediente No. ${escapeHtml(
                countId?.file?.number || "-"
              )}</h1>
              <img class="logo" src="/assets/logo1.png" alt="logo" />
            </div>

            <div class="meta-grid">
              <div><div class="label">Nombre Cliente</div><div class="value">${escapeHtml(
                countId?.name || "-"
              )}</div></div>
              <div><div class="label">Identificacion</div><div class="value">${escapeHtml(
                countId?.document || "-"
              )}</div></div>
              <div><div class="label">Fecha de Nacimiento</div><div class="value">${escapeHtml(
                countId?.birth || "-"
              )}</div></div>
            </div>

            <div class="meta-grid-4">
              <div><div class="label">Tipo de Pension</div><div class="value">${escapeHtml(
                pension_type(countId?.pension_type) || "-"
              )}</div></div>
              <div><div class="label">Tipo de Conteo</div><div class="value">${escapeHtml(
                count_type(countId?.count_type) || "-"
              )}</div></div>
              <div><div class="label">Conteo Numero</div><div class="value">${escapeHtml(
                countId?.id || "-"
              )}</div></div>
              <div><div class="label">Responsable</div><div class="value">${escapeHtml(
                countId?.user?.full_name || "-"
              )}</div></div>
            </div>

            <table class="items-table">
              <thead>
                <tr>
                  <th>Empleador</th>
                  <th>Cotizado A</th>
                  <th>Tipo Aporte</th>
                  <th>Ingreso</th>
                  <th>Egreso</th>
                  <th>Total Parcial</th>
                  <th>Dias Sim</th>
                  <th>Total Dias</th>
                </tr>
              </thead>
              <tbody>${rowsItems || '<tr><td colspan="8">Sin items</td></tr>'}</tbody>
            </table>

            <div class="summary-block">
              <div class="summary-head">
                <h3 class="summary-title">Resumen</h3>
                <div class="totals">Total Dias: ${daysTotal} | TOTAL SEMANAS: ${weekTotal}</div>
              </div>

              <table class="resumen-table">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>Anos</th>
                    <th>Meses</th>
                    <th>Dias</th>
                    <th>Semanas</th>
                  </tr>
                </thead>
                <tbody>${rowsResumen}</tbody>
              </table>

              <h3 class="obs-title">Observaciones</h3>
              <div class="obs">${escapeHtml(observations)}</div>
            </div>

            <div class="print-footer">
              <span>Impreso por: ${escapeHtml(localStorage.full_name || "-")}</span>
              <span>Fecha de impresion: ${Moment().format("D [de] MMMM [del] YYYY, h:mm a")}</span>
            </div>
          </div>
        </body>
      </html>`;

      const iframe = window.document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const frameWindow = iframe.contentWindow;
      frameWindow.document.open();
      frameWindow.document.write(printHtml);
      frameWindow.document.close();

      setTimeout(() => {
        frameWindow.focus();
        frameWindow.print();
        iframe.remove();
      }, 450);
    }

    return (
      <div>
         <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item">
          <Link to="/Conteos">Conteos</Link>
        </li>
        <li className="breadcrumb-item active">
          <Link to="#">Conteo # {countId?.id} </Link>
        </li>
        {/* <li className="breadcrumb-item active">Data Tables</li> */}
      </ol>
      <h1 className="page-header">Conteo # {countId?.id}  </h1>
  <div className="w-100 d-flex justify-content-end"><button title="Imprimir"
                onClick={()=>{
                  printLikeLegacy(countId)}}
                className="btn btn-sm btn-white mb-10px ms-auto me-0"
              >
                <i className="fa fa-print t-plus-1 fa-fw fa-lg"></i>
              </button></div>
      
              
     { !countId.id?<div className="fa-3x d-flex justify-content-center"> 
        <i className="fas fa-cog fa-spin"></i> </div>:   <Panel>
          <PanelHeader>Conteo # {countId?.id}</PanelHeader>
         
          <div className="hljs-wrapper" >
          <div className="profile-content">
            <div className="tab-content p-0">
             
              {countId.items && countId.items?.length>0?<div className="table-responsive" id={"printerNow"}>
              <TablePrueba   data={countId.items?countId.items:[]}  columnsData={columnsForTable} pagination={true} > </TablePrueba>
              <br />
              </div>:null}
                <div className=" form-inline">
          <div className="">
                    <div style={{ textAlign: "right" }} className="row">
                      <div className="col">
                        <span
                          className="px-2"
                          style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                          TOTAL DÍAS : {countId?.days_total}
                        </span>{" "}
                        <span
                          className=" px-2"
                          style={{
                            fontWeight: "bold",
                            fontSize: "1rem",
                            borderLeft: "1px solid gray",
                          }}
                        >
                          TOTAL SEMANAS :{Math.round(countId?.days_total / 7)}
                        </span>
                      </div>
                    </div>
                  </div></div>
                  <br />
                  <PerfectScrollbar id={"secondTablePrint"} >
                
                    <table   className="table table-panel table-bordered mb-0" style={{minWidth:"40rem"}}>
                      <thead
                     
                        style={{
                        
                          fontSize: "1rem",
                        }}
                      >
                        <tr className="d-flex ">
                          <th className="col-4">Resumen</th>
                          <th className="col text-center">Calculo</th>
                          <th className="col text-center">Años </th>
                          <th className="col text-center">Meses</th>
                          <th className="col text-center">Días</th>
                          <th className="col text-center">Semana</th>
                        </tr>
                      </thead>
                      <tbody>
                 
                        <tr className="d-flex">
                          <td className="col-4">
                            Público No Cotizado a Cajas
                          </td>
                          <td className="col text-center">
                            {countId?.public_no_fund}
                          </td>
                          <td className="col text-center ">
                            {discriminate(countId?.public_no_fund, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_no_fund, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_no_fund, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_no_fund, "weeks")}
                          </td>
                        </tr>
                    
                    
                        <tr className="d-flex">
                          <td className="col-4">Público Cotizado a Cajas</td>
                          <td className="col text-center">
                            {countId?.public_fund}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_fund, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_fund, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_fund, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_fund, "weeks")}
                          </td>
                        </tr>
                     
                 
                        <tr className="d-flex">
                          <td className="col-4">Fondo</td>
                          <td className="col text-center">
                            {countId?.fund}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.fund, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.fund, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.fund, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.fund, "weeks")}
                          </td>
                        </tr>
                     
                  
                        <tr className="d-flex">
                          <td className="col-4">Total Público</td>
                          <td className="col text-center">
                            {countId?.public_total}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_total, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_total, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_total, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.public_total, "weeks")}
                          </td>
                        </tr>
                    
                  
                        <tr className="d-flex">
                          <td className="col-4">
                            Tiempo Cotizado al 1 Abril 94
                          </td>
                          <td className="col text-center">
                            {countId?.time_94}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.time_94, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.time_94, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.time_94, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.time_94, "weeks")}
                          </td>
                        </tr>
                      
                  
                        <tr className="d-flex">
                          <td className="col-4 my-auto">
                            Tiempo Cotizado al 22 de Julio 2005
                          </td>
                          <td className="col text-center my-auto">
                            {countId?.time_2005}
                          </td>
                          <td className="col text-center my-auto">
                            {discriminate(countId?.time_2005, "year")}
                          </td>
                          <td className="col text-center my-auto">
                            {discriminate(countId?.time_2005, "months")}
                          </td>
                          <td className="col text-center my-auto">
                            {discriminate(countId?.time_2005, "days")}
                          </td>
                          <td className="col text-center my-auto">
                            {discriminate(countId?.time_2005, "weeks")}
                          </td>
                        </tr>
                     
                   
                        {" "}
                        <tr className="d-flex">
                          <td className="col-4">Privado Tradicionales</td>
                          <td className="col text-center">
                            {countId?.private_traditional}{" "}
                          </td>
                          <td className="col text-center">
                            {discriminate(
                              countId?.private_traditional,
                              "year"
                            )}
                          </td>
                          <td className="col text-center">
                            {discriminate(
                              countId?.private_traditional,
                              "months"
                            )}
                          </td>
                          <td className="col text-center">
                            {discriminate(
                              countId?.private_traditional,
                              "days"
                            )}
                          </td>
                          <td className="col text-center">
                            {discriminate(
                              countId?.private_traditional,
                              "weeks"
                            )}
                          </td>
                        </tr>
                      
                 
                        <tr className="d-flex">
                          <td className="col-4">Privado Autoliss</td>
                          <td className="col text-center">
                            {countId?.private_autoliss}{" "}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_autoliss, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_autoliss, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_autoliss, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_autoliss, "weeks")}
                          </td>
                        </tr>
                      
                  
                        <tr className="d-flex">
                          <td className="col-4">Total Privado</td>
                          <td className="col text-center">
                            {countId?.private_total}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_total, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_total, "months")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_total, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.private_total, "weeks")}
                          </td>
                        </tr>
                     
                     
                        <tr className="d-flex">
                          <td className="col-4">Total Cotizaciones</td>
                          <td className="col text-center">
                            {countId?.total_contributions}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.total_contributions, "year")}
                          </td>
                          <td className="col text-center">
                            {discriminate(
                              countId?.total_contributions,
                              "months"
                            )}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.total_contributions, "days")}
                          </td>
                          <td className="col text-center">
                            {discriminate(countId?.total_contributions, "weeks")}
                          </td>
                        </tr>
                       </tbody>
                    </table>
                  </PerfectScrollbar>
          <ReactNotifications />
          <Modal
            isOpen={this.state.modalReject}
            toggle={() => this.toggleModal("modalReject")}
          >
            <ModalHeader
              // toggle={() => setmodalAsignment(!modalAsignment)}
              close={
                <button
                  className="btn-close"
                  onClick={() => {
                    this.toggleModal("modalReject");
                  }}
                ></button>
              }
            >
              Rechazar Expediente
            </ModalHeader>
            <form onSubmit={this.submitReject}>
              <ModalBody>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="d-flex  mx-auto" style={{ width: "80%" }}>
                    <div className="field m-auto">Comentario</div>
                    <div>
                      <textarea
                        onChange={(e) =>
                          this.setState({ comentarioAsignar: e.target.value })
                        }
                        placeholder="Escribe tu comentario"
                        className="w-300px m-auto p-2"
                        style={{
                          borderColor: "hsl(0, 0%, 80%)",
                          borderRadius: "4px",
                        }}
                      ></textarea>
                    </div>
                  </div>
                  {this.state.AsignaraCommentError ? (
                    <div className="d-flex mx-auto" style={{ width: "80%" }}>
                      <div className="w-75px field m-auto "></div>
                      <div className="w-300px m-auto">
                        {" "}
                        <span style={{ color: "red" }}>
                          Este campo es necesario
                        </span>{" "}
                      </div>{" "}
                    </div>
                  ) : null}
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    this.toggleModal("modalReject");
                  }}
                >
                  Cerrar
                </button>
                <button type="submit" className="btn btn-danger">
                  Rechazar
                </button>
              </ModalFooter>
            </form>
          </Modal>
          {this.state.sweetAlertError && (
            <SweetAlert
              danger
              showCancel
              confirmBtnText="Yes, delete it!"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title="Are you sure?"
              onConfirm={() => {
        
                deleteCountId(this.state.path);
                this.handleSubmit();
              }}
              onCancel={() => this.toggleSweetAlert("error")}
            >
              You will not be able to recover this imaginary file!
            </SweetAlert>
          )}
          
         
          </div>
          </div>
          </div>
        </Panel>}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  filesLoaded: state.counterSlice.filesLoaded,
  fileId: state.counterSlice.fileId,
  users: state.counterSlice.users,
  countId: state.counterSlice.countId,
});
const mapDispatchToProps = {
  
  removeFilesOpen,
  getFilesId,

  getUsers,
  getCountsId,deleteCountId
};

// bind our actions to this.props

export default connect(mapStateToProps, mapDispatchToProps)(VerConteo);
